import React from "react"
import PropTypes from "prop-types"
import "./device-list.scss"
import Device from "./device"
import { toMoney } from "../../utils/string_utils"

const DeviceList = ({ devices = [], onSelect, excludeVAT }) => (
  <div className="device-list">
    {devices.map(device => (
      <Device
        key={`DEVICE_${device.id}`}
        id={device.id}
        name={device.name}
        rating={device.rating}
        availableColors={device.availableColors}
        details={device.details}
        costText={`From ${toMoney(device.minimumCost, "£")} a month`}
        type={device.type}
        image={device.img}
        onClick={onSelect}
        excludeVAT={excludeVAT}
      />
    ))}
  </div>
)

DeviceList.propTypes = {
  devices: PropTypes.arrayOf(PropTypes.object).isRequired,
  excludeVAT: PropTypes.bool,
  onSelect: PropTypes.func.isRequired
}

DeviceList.defaultProps = {
  excludeVAT: false
}

export default DeviceList
